import { contentContainerStyle } from '@/components/ui/Layout/ContentContainer/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailViewLayout のスタイル
 */
export const hotlineProDetailLayoutStyle = tv({
    slots: {
        alert: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            contentContainerStyle({ maxWidthPoint: 'xl' }),
            'text-center',
            'p-16',
            'mx-auto mt-16',
            'bg-gray-300',
            'rounded-md',
        ],
        attentionPointContent: [
            'flex flex-col gap-16',
            'p-16',
            'mb-8',
            'bg-white',
            'shadow-md',
            'md:rounded-md',
        ],
        attentionPointTitle: [
            headStyle({ color: 'base', isBold: true, size: 'xs' }),
        ],
        attentionPointTitleWrap: ['flex items-center gap-4'],
        content: [
            contentContainerStyle({ isMinWidthFull: true, maxWidthPoint: 'xl' }),
            'mt-32 mx-auto',
        ],
        head: [
            contentContainerStyle({ maxWidthPoint: 'xl' }),
            'flex flex-col gap-8',
            'mx-auto',
        ],
        headContent: [
            'lg:pt-20',
            'lg:bg-gradient-to-r lg:from-gradient-dark-green-from lg:to-gradient-dark-green-to',
            'lg:bg-[length:100%_calc(100%-32px)] lg:bg-no-repeat',
        ],
        headContentInner: [
            'max-lg:py-20',
            'max-lg:bg-gradient-to-r max-lg:from-gradient-dark-green-from max-lg:to-gradient-dark-green-to',
            'max-lg:bg-100% max-lg:bg-no-repeat',
        ],
        headText: [headStyle({ color: 'white', size: 'sm' })],
        steps: [contentContainerStyle({ maxWidthPoint: 'xl' }), 'mx-auto mt-32'],
    },
    variants: {
        hasAlert: {
            false: {
                steps: ['lg:mt-24'],
            },
            true: {
                steps: ['lg:mt-16'],
            },
        },
    },
});
